import { Link } from "react-router-dom";
import { Button, Result } from "antd";
// import { restTabList, setCurrentMenu } from 'store/reducers/tab';
// import { useDispatch } from "react-redux";

export default function NotFoundPage() {
  // const dispatch = useDispatch();

  return (
    <div style={{ maxWidth: 800, margin: "100px auto" }}>
      <Result
        status="404"
        title="页面不存在"
        subTitle="您访问的页面待开发或暂时不可用"
        extra={
          <Button type="primary">
            <Link to="/">返回首页</Link>
          </Button>
        }
      />
    </div>
  );
}
